export const PortfolioCreationChoice = {
    CreatePortfolioManualCompositionFunds: "CreatePortfolioManualCompositionFunds",
    CreatePortfolioManualCompositionInvestorAccounts: "CreatePortfolioManualCompositionInvestorAccounts",
    CreatePortfolioRuleBased: "CreatePortfolioRuleBased",
    CreatePortfolioRuleBasedFunds: "CreatePortfolioRuleBasedFunds"
};
